import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';
import Input from '../../Form/Field/Input.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';
import Select from '../../Form/Field/Select.jsx';
import validate from './validate.js';

export const name = 'DropNeedForm';

class DropNeedForm extends Component {
  static propTypes = {
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  render() {
    return (
      <div id={name} className={this.props.className}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Nom : *"
                name="lastname"
                placeholder="Nom"
                type="text"
                component={Input}
              />
            </div>
            <div className="col-md-6">
              <Field
                label="Société : *"
                name="company"
                placeholder="Société"
                type="text"
                component={Input}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="E-mail : *"
                name="email"
                placeholder="E-mail"
                type="text"
                component={Input}/>
            </div>
            <div className="col-md-6">
              <Field
                label="Numéro de téléphone : *"
                name="tel"
                placeholder="06 10 11 12 21"
                type="text"
                component={Input}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mb-3">
              <Field
                label="Domaine : *"
                name="universe"
                component={Select}>
                {this.props.universes.map((universe) => (
                  <option value={universe.id} key={universe.id}>{universe.name}</option>
                ))}
              </Field>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mb-3">
              <Field
                label="Description :"
                name="description"
                type="textarea"
                component={Input}
              />
              <em>
                Contexte, type de profil recherché, expérience attendue, localisation de la mission et durée
                de la mission initiale et espérée, % télétravail accepté. SVP précisez ce qui est obligatoire
                et ce qui est préférable.
              </em>
            </div>
          </div>
          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
      </div>
    );
  }
}

const ReduxDropNeedForm = reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name)
})(DropNeedForm);

export default connect(
  (state) => ({
    universes: state.universe.universes
  })
)(ReduxDropNeedForm)
